<template>
	<div
		style="width: 95%"
		class="ml-5"
	>
		<loading-overlay
			:active="isLoaded"
			:can-cancel="true"
		/>
		<base-block
			title="Existing Layouts"
			header-bg
		>
			<div
				ref="layoutTable"
			/>
		</base-block>
	</div>
</template>
